import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

export default inject('sessionStore')(observer(class CheckSession extends Component {
  validateSession () {
    const { sessionStore } = this.props
    return sessionStore
      .authenticate()
  }

  componentDidMount () {
    this.validateSession()
  }

  render () {
    return (
      <>
        {this.props.children}
      </>
    )
  }
}))
